// API-shaping helpers for the Actions toolkit: everything that talks to the
// backend without touching React state.

import ActionsApi from '../../api/actions';
import CategoriesApi from '../../api/categories';

export async function resolveCategoryUuid(categoryName) {
  const response = await CategoriesApi.listCategories();
  const match = (response.data || []).find(
    (c) => c.attributes.name === categoryName,
  );
  return match?.id || null;
}

// The three schemas travel together on every create/update/version call.
export const schemaPayload = (data) => ({
  input_schema: data.inputSchema,
  output_schema: data.outputSchema,
  metadata_schema: data.metadataSchema,
});

// The migrate endpoint wants integration uuids, but the UI carries names; the
// source version's assignment list is what bridges the two.
export async function resolveIntegrationUuids(sourceUuid, names) {
  const rows =
    (await ActionsApi.fetchActionIntegrations(sourceUuid)).data || [];
  const nameToUuid = {};
  rows.forEach((row) => {
    nameToUuid[row.attributes.name] = row.id;
  });
  return names.map((n) => nameToUuid[n]).filter(Boolean);
}

// Returns the pretty-printed document, or the response so the caller can report
// why it could not be produced.
export async function exportActionDocument(versionUuid) {
  const response = await ActionsApi.exportAction(versionUuid);
  if (response.errors || !response.data) return { text: null, response };
  return { text: JSON.stringify(response.data, null, 2), response };
}

export function downloadJson(text, filename) {
  const url = URL.createObjectURL(
    new Blob([text], { type: 'application/json' }),
  );
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
